<template>
    <b-list-group-item :disabled="isDisabled" @click="goToNext()">
        <div >
            <b-row>
                <b-col cols="11" class="list-title">
                    {{ getStringSubstringed(model.deliveryInstructionNumber,15) }}
                </b-col>
                <b-col cols="1">
                    <div class="item-box">
                        <span :class="getRectangleClass(model.deliveryQualityInspectionStatusCode)">&nbsp;</span>
                    </div>
                </b-col>
            </b-row>
        </div>
    </b-list-group-item>
</template>
<script>
export default {
    props: {
        model: {
            default: {},
            type: Object
        },
        isDisabled: {
            default: Boolean,
            type: false
        }
    },
    methods: {
        goToNext() {
            if (!this.isDisabled) {
                this.$emit('nextAction');
            }
        },
        getStringSubstringed(valueString,length){
            if (valueString.length<length) {
                return valueString;
            }
            return valueString.substring(0,length) + "...";
        },
        getRectangleClass(documentStatus) {
			documentStatus = documentStatus.toUpperCase();
			let cls = "rectangle";
			if(documentStatus == "DONE") {
				cls += " rectangle-success";
			} else if(documentStatus == "IN_PROGRESS" || documentStatus == "IN_PROGRESS_PRODUCTION" || documentStatus == "IN_PROGRESS_RFP") {
				cls += " rectangle-warning";
			} else {
				cls += " rectangle-danger";
			}

			return cls;
		},
        padTo2Digits(num) {
            return num.toString().padStart(2, '0');
        }
    },
    computed: {
        getStatusStyle() {
            return {
                color: this.model.isScanned == null || this.model.isScanned == false ? 'red' : 'green',
                // Add more styles as needed
            };
        },
    },
}
</script>
<style>
.scanStatus {
    display: flex;
    font-size: 14px !important;
    align-items: center;
    justify-content: flex-end;
}		
.item-box {
    display: flex;
    padding: 10px;
    align-items: center;
}
.rectangle {
    min-width: 30px;
    min-height: 30px;
}
.rectangle-danger {
    background-color: #DC3545;
}
.rectangle-warning {
    background-color: #FFC107;
}
.rectangle-success {
    background-color: #28A745;
}
</style>